import { styled as r } from "styled-components";
import { Caption as e } from "../../styles/typography/index.js";
import { Theme as o } from "../../styles/themes/index.js";
import { Colors as t } from "../../styles/colors/index.js";
import { Icon as i } from "../Icon/index.js";
const m = r.li`
  ${e}
  padding: 12px 20px;
  display: flex;
  align-items: center;
  list-style: none;
  cursor: pointer;
  background-color: rgb(${o.colors.Juliet});
  color: rgb(${o.colors.Alpha});
  justify-content: space-between;

  &:hover {
    background-color: rgb(${o.colors.Kilo});
  }

  &[aria-selected='true'] {
    background-color: rgb(${o.colors.Kilo});
  }
`, a = r.div`
  display: flex;
  align-items: center;
`, d = r.div`
  margin-right: 8px;
  display: flex;
`, g = r(i)`
  font-size: 24px;
  color: rgb(${t.Green});
`;
export {
  m as ListItemContainer,
  d as ListItemIcon,
  a as ListItemLeftContent,
  g as SelectedIcon
};
